// Campos que fija la selección de un PDF del CMS y que se vacían al quitarlo.
export const CONVERSION_PDF_FIELDS = ['pdf_file_name', 'source_ref_guid', 'source_url', 'page_count', 'has_metadata', 'is_pedagogy_complete'];

export const CONVERSION_RANGE_FIELDS = ['page_from', 'page_to'];

// Catálogo pedagógico que exige v3 para convertir; se autorrellena desde el PDF y sigue editable.
export const CONVERSION_PEDAGOGY_FIELDS = ['educationLevel', 'educationYear', 'discipline'];

// El País no viaja al DTO (v3 lo prohíbe en modo convert): solo filtra Etapa y Asignatura en
// tenants multipaís, donde ambos catálogos son por país.
export const CONVERSION_FILTER_FIELDS = ['country'];

// v3 deriva el nombre de fichero del último segmento de `source_url`; sin él rechaza el lote.
export function getSourceUrlFileName(url) {
  const path = String(url ?? '')
    .trim()
    .split(/[?#]/)[0];

  return path.split('/').pop().trim();
}

// Número de páginas de un rango inclusivo; 0 cuando el rango no es válido.
export function getConversionPageSpan(pageFrom, pageTo) {
  const from = Number(pageFrom);
  const to = Number(pageTo);
  if (!Number.isInteger(from) || !Number.isInteger(to) || from < 1 || to < from) return 0;

  return to - from + 1;
}

const isFilled = (value) => value !== '' && value !== null && value !== undefined;

// Qué obligatorios quedan sin rellenar, en el orden en que aparecen en la pantalla. Devuelve claves,
// no rótulos: quién lo pinta decide cómo se llama cada campo. El rango cuenta como uno solo, porque
// "Desde" y "Hasta" por separado no le dicen nada al editor.
export function getMissingConversionFields(values = {}, { isMultiCountry = false } = {}) {
  return [
    !isFilled(values.name) && 'name',
    !values.pdf_file_name && 'pdf_file_name',
    isMultiCountry && !values.country && 'country',
    (!isFilled(values.page_from) || !isFilled(values.page_to)) && 'pages',
    !values.educationLevel && 'educationLevel',
    !values.educationYear && 'educationYear',
    !values.discipline && 'discipline',
  ].filter(Boolean);
}

// Nota del PDF elegido: un contenido que aporta parte del catálogo sí autorrellenó algo, así que no
// vale negar que tenga metadatos. Sin nota cuando no hay PDF o el catálogo está completo.
export function getConversionPdfNoteKey(values = {}) {
  if (!values.pdf_file_name || values.is_pedagogy_complete !== false) return '';

  return values.has_metadata ? 'activityBatches:pdf_partial_metadata' : 'activityBatches:pdf_no_metadata';
}
